var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Helper functions for custom layers and models.
 * These utils are generic and have nothing to do with GPT model itself.
 */
import * as tf from '@tensorflow/tfjs';
export function withModelHelpers(model, children) {
    var _this = this;
    return __assign(__assign({}, model), { dispose: function () { return dispose(children.flat()); }, getWeights: function () { return __awaiter(_this, void 0, void 0, function () {
            var weights, layers, _i, layers_1, layer, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        weights = {};
                        layers = flatChildren(children);
                        _i = 0, layers_1 = layers;
                        _c.label = 1;
                    case 1:
                        if (!(_i < layers_1.length)) return [3 /*break*/, 4];
                        layer = layers_1[_i];
                        _a = weights;
                        _b = layer.name;
                        return [4 /*yield*/, getWeights(layer)];
                    case 2:
                        _a[_b] = _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, truncateFloats(weights)];
                }
            });
        }); }, setWeights: function (weights) {
            var layers = flatChildren(children);
            for (var _i = 0, layers_2 = layers; _i < layers_2.length; _i++) {
                var layer = layers_2[_i];
                var wArr = weights[layer.name];
                if (!wArr) {
                    console.error(new Error("Cannot find weights for layer ".concat(layer.name)));
                    continue;
                }
                var wTens = wArr.map(function (w) { return tf.tensor(w); });
                layer.setWeights(wTens);
                wTens.forEach(function (tensor) { return tensor.dispose(); });
            }
        } });
}
export function withLayerHelpers(layer, children) {
    return __assign(__assign({}, layer), { countParams: function () { return countParams(children.flat()); }, dispose: function () { return dispose(children.flat()); }, getChildren: function () { return children; } });
}
export function dispose(layers) {
    layers.forEach(function (layer) { var _a; return (_a = layer === null || layer === void 0 ? void 0 : layer.dispose) === null || _a === void 0 ? void 0 : _a.call(layer); });
}
export function countParams(layers) {
    return tf.tidy(function () {
        return layers.reduce(function (count, layer) {
            var _a;
            if (!('countParams' in layer))
                return count;
            return count + (((_a = layer === null || layer === void 0 ? void 0 : layer.countParams) === null || _a === void 0 ? void 0 : _a.call(layer)) || 0);
        }, 0);
    });
}
function getWeights(layer) {
    return __awaiter(this, void 0, Promise, function () {
        var promisedWeights, resolvedWeights;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promisedWeights = layer.getWeights() || [];
                    return [4 /*yield*/, Promise.all(promisedWeights.map(function (w) { return w.array(); }))];
                case 1:
                    resolvedWeights = _a.sent();
                    return [2 /*return*/, resolvedWeights];
            }
        });
    });
}
function flatChildren(children) {
    var _a;
    var layers = [];
    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
        var child = children_1[_i];
        // If TensorFlow layer
        if ('trainable' in child) {
            layers.push(child);
        }
        // If custom layer
        else if ('getChildren' in child) {
            flatChildren(((_a = child.getChildren) === null || _a === void 0 ? void 0 : _a.call(child)) || []).forEach(function (childLayer) {
                layers.push(childLayer);
            });
        }
        // If array of layers
        else if (Array.isArray(child)) {
            flatChildren(child).forEach(function (childLayer) {
                layers.push(childLayer);
            });
        }
    }
    return layers;
}
// Truncates the weights of the layers to `fractionDigits` number of
// digits after the floating point (to reduce the checkpoint file size).
// Be aware, that this would increase the model loss after checkpoint import.
function truncateFloats(obj, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 8; }
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return truncateFloats(item); });
    }
    else if (typeof obj === 'object' && obj !== null) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = truncateFloats(obj[key]);
            }
        }
        return obj;
    }
    else if (typeof obj === 'number' && !Number.isInteger(obj)) {
        return parseFloat(obj.toFixed(fractionDigits));
    }
    return obj;
}
